import {Box, Button, Flex, Image, Spacer,Text, VStack} from "@chakra-ui/react";
import React from "react";

import AudioRecorder from "../../shared/components/AudioRecorder";
import Markdown from "../../shared/components/Markdown";
import RenderResource from "../../shared/components/RenderResource";
import {useFont} from "../../shared/hooks/FontProvider";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import {customButtonProps, SkillType} from "../../shared/model/Constants";
import { TestDto } from "../../shared/model/Dto";
import {isInAvataiSite, validResourceExtension} from "../../shared/Utils";

type TestStartProps = {
  test: TestDto;
  isLoading: boolean;
  onTestStart: () => void;
};

const TestStart = (props: TestStartProps) => {
  const theme = useTheme().theme;
  const font = useFont().font;
  const isAvatai = isInAvataiSite();
  return (
    <Flex justify="center" align="space-between" paddingLeft={5}>
        <Box width="2xl">
          <Box>
            { validResourceExtension(props.test.description)
              ? <RenderResource resource={props.test.description} />
              : <Markdown content={props.test.description} />
            }
          { props.test.skillType === SkillType.LISTENING &&
            <>
              <Text>Test Audio Player</Text>
              <RenderResource
              resource="AudioTest.mp3"
            />
            </>}
          { props.test.skillType === SkillType.SPEAKING &&
            <>
              <Text>Test Audio Recorder</Text>
              <AudioRecorder demo={true}/>
            </>}
          </Box>

          <Box textAlign="right"  marginRight={5}>
            <Button isLoading={props.isLoading} onClick={props.onTestStart}
                    {...customButtonProps(isAvatai)}
                fontWeight={font.weight}
                fontSize={font.buttonText}>
              Start
            </Button>
          </Box>
        </Box>
      <Spacer/>
      <VStack alignSelf="center">
        <Image
            src={props.test.skillType === SkillType.LISTENING ? "/images/img-79f7e62e8345e3295c80ee73f4a7f6692d625247.jpg" : "/images/b996-2e23-0d3e-e998.png"}
            //maxH={props.test.skillType === SkillType.LISTENING ? "2xs" : "xl"}
            alignSelf="center"
        />
      </VStack>
    </Flex>
  );
};

export default TestStart;
